import * as React from 'react';
import * as styles from './List.css';

export const List = (props: React.PropsWithChildren) => {
  return <ul className={styles['list']}>{props.children}</ul>;
};
